import PropTypes from "prop-types"

// Disable alphabetical ordering to make it easier to scan for pairings (e.g.
// origin + destination)
/* eslint-disable react/sort-prop-types */
export default PropTypes.shape({
  tempZone: PropTypes.string.isRequired,
  units: PropTypes.number.isRequired,
  pallets: PropTypes.string.isRequired,
  day: PropTypes.string.isRequired,
})
